import { createSelector } from 'reselect';
import { prop } from 'ramda';

const localState = prop('dictionary');

export const getDictionaryLoading = createSelector(
  localState,
  prop('loading'),
);
